"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOrientationSearchResultItemDto = instanceOfOrientationSearchResultItemDto;
exports.OrientationSearchResultItemDtoFromJSON = OrientationSearchResultItemDtoFromJSON;
exports.OrientationSearchResultItemDtoFromJSONTyped = OrientationSearchResultItemDtoFromJSONTyped;
exports.OrientationSearchResultItemDtoToJSON = OrientationSearchResultItemDtoToJSON;
exports.OrientationSearchResultItemDtoToJSONTyped = OrientationSearchResultItemDtoToJSONTyped;
const SpecialtyAbbrDto_1 = require("./SpecialtyAbbrDto");
const StipendDto_1 = require("./StipendDto");
const FacilityDto_1 = require("./FacilityDto");
const OrientationStatus_1 = require("./OrientationStatus");
const ShiftRequestAbbrDto_1 = require("./ShiftRequestAbbrDto");
const LicenseType_1 = require("./LicenseType");
const OrientationSessionDto_1 = require("./OrientationSessionDto");
/**
 * Check if a given object implements the OrientationSearchResultItemDto interface.
 */
function instanceOfOrientationSearchResultItemDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('licenseType' in value) || value['licenseType'] === undefined)
        return false;
    if (!('payRate' in value) || value['payRate'] === undefined)
        return false;
    if (!('totalRate' in value) || value['totalRate'] === undefined)
        return false;
    if (!('orientationSessions' in value) || value['orientationSessions'] === undefined)
        return false;
    if (!('totalSeats' in value) || value['totalSeats'] === undefined)
        return false;
    if (!('openSeats' in value) || value['openSeats'] === undefined)
        return false;
    if (!('facility' in value) || value['facility'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('specialtyCode' in value) || value['specialtyCode'] === undefined)
        return false;
    if (!('startTime' in value) || value['startTime'] === undefined)
        return false;
    if (!('isQualifiedForStipend' in value) || value['isQualifiedForStipend'] === undefined)
        return false;
    return true;
}
function OrientationSearchResultItemDtoFromJSON(json) {
    return OrientationSearchResultItemDtoFromJSONTyped(json, false);
}
function OrientationSearchResultItemDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'licenseType': (0, LicenseType_1.LicenseTypeFromJSON)(json['licenseType']),
        'description': json['description'] == null ? undefined : json['description'],
        'payRate': json['payRate'],
        'totalRate': json['totalRate'],
        'orientationSessions': (json['orientationSessions'].map(OrientationSessionDto_1.OrientationSessionDtoFromJSON)),
        'totalSeats': json['totalSeats'],
        'openSeats': json['openSeats'],
        'facility': (0, FacilityDto_1.FacilityDtoFromJSON)(json['facility']),
        'status': (0, OrientationStatus_1.OrientationStatusFromJSON)(json['status']),
        'specialtyCode': json['specialtyCode'],
        'specialty': json['specialty'] == null ? undefined : (0, SpecialtyAbbrDto_1.SpecialtyAbbrDtoFromJSON)(json['specialty']),
        'startTime': (new Date(json['startTime'])),
        'stipends': json['stipends'] == null ? undefined : (json['stipends'].map(StipendDto_1.StipendDtoFromJSON)),
        'stipendMinimumDistance': json['stipendMinimumDistance'] == null ? undefined : json['stipendMinimumDistance'],
        'isSearchable': json['isSearchable'] == null ? undefined : json['isSearchable'],
        'isQualifiedForStipend': json['isQualifiedForStipend'],
        'request': json['request'] == null ? undefined : (0, ShiftRequestAbbrDto_1.ShiftRequestAbbrDtoFromJSON)(json['request']),
        'distance': json['distance'] == null ? undefined : json['distance'],
    };
}
function OrientationSearchResultItemDtoToJSON(json) {
    return OrientationSearchResultItemDtoToJSONTyped(json, false);
}
function OrientationSearchResultItemDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'licenseType': (0, LicenseType_1.LicenseTypeToJSON)(value['licenseType']),
        'description': value['description'],
        'payRate': value['payRate'],
        'totalRate': value['totalRate'],
        'orientationSessions': (value['orientationSessions'].map(OrientationSessionDto_1.OrientationSessionDtoToJSON)),
        'totalSeats': value['totalSeats'],
        'openSeats': value['openSeats'],
        'facility': (0, FacilityDto_1.FacilityDtoToJSON)(value['facility']),
        'status': (0, OrientationStatus_1.OrientationStatusToJSON)(value['status']),
        'specialtyCode': value['specialtyCode'],
        'specialty': (0, SpecialtyAbbrDto_1.SpecialtyAbbrDtoToJSON)(value['specialty']),
        'startTime': ((value['startTime']).toISOString()),
        'stipends': value['stipends'] == null ? undefined : (value['stipends'].map(StipendDto_1.StipendDtoToJSON)),
        'stipendMinimumDistance': value['stipendMinimumDistance'],
        'isSearchable': value['isSearchable'],
        'isQualifiedForStipend': value['isQualifiedForStipend'],
        'request': (0, ShiftRequestAbbrDto_1.ShiftRequestAbbrDtoToJSON)(value['request']),
        'distance': value['distance'],
    };
}
//# sourceMappingURL=OrientationSearchResultItemDto.js.map